import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';

const AdminHome = () => {
  const [stats, setStats] = useState({
    totalClase: 0,
    totalEducatoare: 0,
    comenziAzi: 0,
    comenziActive: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await axios.get('/api/admin/dashboard');
      setStats(response.data);
    } catch (error) {
      console.error('Eroare la încărcare statistici:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Se încarcă...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Vedere generală a platformei</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon green">🏫</div>
          <div className="stat-info">
            <h3>Total Clase</h3>
            <p>{stats.totalClase}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon blue">👩‍🏫</div>
          <div className="stat-info">
            <h3>Educatoare</h3>
            <p>{stats.totalEducatoare}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon orange">📝</div>
          <div className="stat-info">
            <h3>Comenzi Astăzi</h3>
            <p>{stats.comenziAzi}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon purple">⏳</div>
          <div className="stat-info">
            <h3>Comenzi Active</h3>
            <p>{stats.comenziActive}</p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">Bine ai venit!</div>
        <p>Folosește meniul din stânga pentru a gestiona clasele, meniul, comenzile și utilizatorii platformei.</p>
      </div>
    </div>
  );
};

export default AdminHome;
